import React from 'react';
import styled from 'styled-components';
import { useStaticQuery, graphql } from 'gatsby';
import Select from 'gatsby-theme-forms/src/components/select/dropdown';

const Vehicles = ({
  className,
  ...props
}) => {
  const { vehicles } = useStaticQuery(graphql`
    query UseAllVehiclesInForm {
      vehicles: allStrapiVehicle(
        sort: { licensePlate: ASC }
      ) {
        nodes {
          licensePlate
          name
        }
      }
    }
  `);

  const values = vehicles.nodes.map(({ licensePlate, name }) => ({
    value: `${licensePlate} (${name})`,
  }));
  return (
    <Select
      className={className}
      values={values}
      defaultOptionTitle="Kies een auto..."
      alwaysShowDefaultOption
      {...props}
    />
  );
};

export default styled(Vehicles)``;
